import axios from 'axios';
export const getEventType = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`event-type`);
};

export const AddEventType = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-type/create`,
    obj,
    { headers }
  );
};

export const EditEventType = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-type/update`,
    obj,
    { headers }
  );
};

export const DeleteEventType = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-type/delete`,
    obj,
    { headers }
  );
};
